import React from 'react'
import { Breadcrumb, BreadcrumbItem, Container } from 'react-bootstrap'
import { useState } from 'react';
import { GetCmsPages } from '../api.services.js/others';

export const getServerSideProps = async () => {
  const {data} = await GetCmsPages({identifier:"chote-bathrooms"})
  return {
    props: {data},
  };
};
const Quality = (props) => {
  const [cmsPage, setcmsPage] = useState(props?.data?.cmsPage?.content)
 
  return (
    <>
   
     <div className='quality-certificates'>
       <Container>
        <div dangerouslySetInnerHTML={{ __html: cmsPage }}></div>
       </Container>
     </div>
    </>
  )
}

export default Quality
